import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { pt } from "@/lib/pt";

export const PartnerLoginSetup = ({ token, username, onDone }) => {
  const [f, setF] = useState({ username: username || "", password: "" });
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (f.password.length < 6) return toast.error("Password should be at least 6 characters.");
    setBusy(true);
    try { await api.put(`/partner/${token}/login`, f); toast.success("User ID saved"); setOpen(false); setF({ ...f, password: "" }); onDone?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const field = "h-12 w-full rounded-xl border border-[#D2E0D8] px-4 text-base";
  return (
    <div className="space-y-3 rounded-3xl bg-white p-4" data-testid="partner-login-setup">
      <button onClick={() => setOpen(!open)} className="flex w-full items-center gap-3 text-left" data-testid="partner-login-setup-toggle">
        <KeyRound className="h-6 w-6 text-[#2E9E6B]" />
        <span><span className="block font-bold text-[#0D3B2B]">{username ? `${pt("User ID")}: ${username}` : pt("Create user ID & password")}</span>
          <span className="text-xs text-[#7B968B]">{pt("Optional. You can always log in with your mobile number.")}</span></span>
      </button>
      {open && <>
        <input value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} placeholder={pt("User ID")} autoCapitalize="none" className={field} data-testid="partner-setup-username-input" />
        <input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder={pt("Password (at least 6)")} className={field} data-testid="partner-setup-password-input" />
        <button disabled={busy} onClick={save} className="h-12 w-full rounded-2xl bg-[#0D3B2B] font-bold text-white disabled:opacity-60" data-testid="partner-setup-save-btn">{busy ? "…" : pt("Save")}</button>
      </>}
    </div>
  );
};
